export const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
  setStatus: (state, status: boolean) => {
    state.status = status;
  },
};
